import React, { useRef, useState } from "react";
import FormCreator from "../../components/Forms/FormCreator";
import Buttons from "../../components/ui/button/Buttons";
import MolGrid from "../../components/Grid/MolGrid";
import { InvoiceApprovalData } from "./Data/InvoiceApproval.data";
import { InvoiceApprovalConfig } from "./Data/InvoiceApprovalConfig";

const InvoiceApprovalList = () => {
  const invoiceApprovalRef = useRef(null);
  const [FormData, setFormData] = useState(InvoiceApprovalData);
  const molGridRef = useRef(null);
  const [dataSource, setDataSource] = useState([]);

  const InvoiceApprovalListData = [
    {
      companyName: "Company  A",
      approverName: "John Lim",
      certNumber: "SGP009, SGP009/01",
      overseas: "Yes",
      country: "Singapore",
      pushToXero: "Yes",
      manualInvoiceNumber: "-",
    },
    {
      companyName: "Company  A",
      approverName: "Marcus Tan",
      certNumber: "SGP010",
      overseas: "No",
      country: "Singapore",
      pushToXero: "Yes",
      manualInvoiceNumber: "-",
    },
    {
      companyName: "Company  A",
      approverName: "Yakoob",
      certNumber: "SGP011, SGP012 ",
      overseas: "No",
      country: "Singapore",
      pushToXero: "Yes",
      manualInvoiceNumber: "-",
    },
    {
      companyName: "Company  B",
      approverName: "James Lee",
      certNumber: "SGBP008",
      overseas: "Yes",
      country: "Singapore",
      pushToXero: "No",
      manualInvoiceNumber: "ABC1234",
    },
    {
      companyName: "Company  A",
      approverName: "Mark Lee",
      certNumber: "SGBP0001",
      overseas: "No",
      country: "Malaysia",
      pushToXero: "Yes",
      manualInvoiceNumber: "-",
    },
    {
      companyName: "Company  B",
      approverName: "Aishah Salleh",
      certNumber: "SGBP007",
      overseas: "No",
      country: "China",
      pushToXero: "Yes",
      manualInvoiceNumber: "-",
    },
    {
      companyName: "Company  C",
      approverName: "Maria",
      certNumber: "SGBP0011",
      overseas: "Yes",
      country: "Algeria",
      pushToXero: "Yes",
      manualInvoiceNumber: "-",
    },
  ];

  return (
    <div>
      <div className="crud-requirement-list">
        <div className="corporate-member-list">
          <div className="sgbp-category">
            <div className="row status-input pr-0 col-9">
              <FormCreator ref={invoiceApprovalRef} {...FormData} />
            </div>
            <div className="d-flex align-items-end mb-3 mt-auto gap-3">
              <Buttons
                buttonText="Search"
                buttonTypeClassName="search-btn "
                // onClick={handleSearch}
              />
              <Buttons
                buttonText="Clear"
                buttonTypeClassName="btn btn-secondary"
                // onClick={handleClearClick}
              />
            </div>
          </div>
          <div className="member-list">
            <MolGrid
              ref={molGridRef}
              configuration={InvoiceApprovalConfig}
              dataSource={InvoiceApprovalListData}
              allowPagination={false}
            />
          </div>
          <div className="d-flex justify-content-between mt-5">
            <Buttons
              buttonText="Back"
              buttonTypeClassName="black-btn"
              // onClick={handleBack}
            />
            <div className="d-flex gap-3">
              <Buttons
                buttonText="Reject"
                buttonTypeClassName="danger-btn"
                // onClick={handleReject}
                // isLoading={isChangeKeyPosition}
                // isDisable={isChangeKeyPosition}
              />
              <Buttons
                buttonText="Approve"
                buttonTypeClassName="success-btn"
                // onClick={handleApprove}
                // isLoading={isChangeKeyPosition}
                // isDisable={isChangeKeyPosition}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceApprovalList;
